export const titleCase = (text) => {
  const splitText = text.split(' ')

  for (let i = 0; i < splitText.length; i++) {
    splitText[i] = splitText[i].charAt(0).toUpperCase() + splitText[i].substring(1).toLowerCase();
  }

  return splitText.join(' ')
}